import React, { Fragment, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PhotosCarousel from './photosCarousel';
import Container from '../../components/Container';
import newsPosts from './newsPosts';

const TypographyTitle = styled(Typography)`
    font-weight: bold;
`;

const TypographyContent = styled(Typography)`
    white-space: pre-line;
`;

const ImagePost = styled.img`
    ${props => props.theme.breakpoints.down('xs')} {
        width: 80%;   
    }
    ${props => props.theme.breakpoints.up('sm')} {
        width: 30%;   
    }
`;

const Home = () => {

    useEffect(() => window.scrollTo(0,0));

    return (
        <Fragment>
            <Header />
            <PhotosCarousel />
            <Container>
                <Typography variant="h6">お知らせ</Typography>
                {newsPosts.map((post) => (
                    <Fragment>
                        <TypographyTitle>{post.title}</TypographyTitle>
                        <TypographyContent variant="body2">{post.content}</TypographyContent>
                        {post.photo &&
                            <ImagePost src={post.photo} />
                        }
                    </Fragment>
                ))}
            </Container>
            <Footer />
        </Fragment>
    )
}

export default Home;